// extracted by mini-css-extract-plugin
module.exports = {"introContent":"ArchiveBlock_introContent__H4Ko0"};
module.exports.__checksum = "f3491fc50fe4"
